import { Injectable, InjectionToken } from "@angular/core";
import { Observable } from "rxjs";
import { ConfigurationGetQueryResult } from "../../INTEGRA_Shop_Client";

@Injectable({
  providedIn: 'root'
})
export abstract class IConfigurationApiService {

  abstract configurationGet(useCancellationLogic?: boolean | undefined): Observable<ConfigurationGetQueryResult>;

}

/** Injection token which makes it possible to provide and inject the interface. */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const IConfigurationApiServiceToken = new InjectionToken<IConfigurationApiService>('IConfigurationApiServiceToken');
